<script setup>
import { computed } from 'vue'
import AircraftSilhouette from './AircraftSilhouette.vue'
import { STATUS } from '../lib/status'
import { PART_CALLOUTS, calloutStart } from '../lib/aircraftMap'

const props = defineProps({
  components: { type: Array, required: true },
  selectedId: { type: [Number, String], default: null },
})

const emit = defineEmits(['select'])

// Cor do ponto direto em SVG: fill não aceita as classes do Tailwind.
const DOT_FILL = {
  done: '#22A05B',
  in_progress: '#F5A623',
  active: '#F26A21',
  pending: '#9AA6B2',
}

const callouts = computed(() =>
  props.components
    .filter((c) => PART_CALLOUTS[c.part])
    .map((c) => {
      const { anchor, label, align } = PART_CALLOUTS[c.part]
      return {
        ...c,
        anchor,
        label,
        align,
        start: calloutStart(label, align),
        fill: DOT_FILL[c.state] ?? DOT_FILL.pending,
        stateLabel: (STATUS[c.state] ?? STATUS.pending).label,
      }
    }),
)

const pick = (id) => emit('select', id)
</script>

<template>
  <svg viewBox="-66 -14 330 182" class="w-full">
    <AircraftSilhouette />

    <g
      v-for="item in callouts"
      :key="item.id"
      role="button"
      tabindex="0"
      class="cursor-pointer focus:outline-none"
      :aria-pressed="selectedId === item.id"
      :aria-label="`${item.part}: ${item.stateLabel}`"
      @click="pick(item.id)"
      @keydown.enter.prevent="pick(item.id)"
      @keydown.space.prevent="pick(item.id)"
    >
      <!-- Linha-guia do rótulo até a peça -->
      <line
        :x1="item.start[0]" :y1="item.start[1]"
        :x2="item.anchor[0]" :y2="item.anchor[1]"
        :stroke="selectedId === item.id ? '#0F2A4A' : '#C7D2DE'"
        stroke-width="0.8"
      />

      <!-- Halo de seleção -->
      <circle
        v-if="selectedId === item.id"
        :cx="item.anchor[0]" :cy="item.anchor[1]" r="6"
        fill="none" stroke="#0F2A4A" stroke-width="1.2"
      />

      <circle
        :cx="item.anchor[0]" :cy="item.anchor[1]"
        :r="selectedId === item.id ? 3.6 : 3"
        :fill="item.fill" stroke="#FFFFFF" stroke-width="1.2"
      />

      <text
        :x="item.label[0]" :y="item.label[1]"
        :text-anchor="item.align"
        font-size="7"
        :font-weight="selectedId === item.id ? 700 : 500"
        fill="#0F2A4A"
      >{{ item.part }}</text>

      <!-- Área de clique generosa em volta do rótulo -->
      <rect
        :x="item.align === 'end' ? item.label[0] - 52 : item.align === 'start' ? item.label[0] - 4 : item.label[0] - 26"
        :y="item.label[1] - 8"
        :width="item.align === 'middle' ? 52 : 56"
        height="11"
        fill="transparent"
      />
    </g>
  </svg>
</template>
